var _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 50,
    viewBox: "0 0 135 50",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.0, 0.0 15.0, 38.77612844592548 30.0, 43.183883671614666 45.0, 50.0 60.0, 41.654044229021515 75.0, 28.991214783398974 90.0, 37.109966676764614 105.0, 34.24719781884278 120.0, 44.18359588003635",
    fill: "none",
    stroke: "#ff3a33",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark7);
export default __webpack_public_path__ + "static/media/spark7.45e1ec68013c9bb396153814c6dadb55.svg";
export { ForwardRef as ReactComponent };